
import './App.css';
import Footer from './Component/Footer';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import Home from './Home';
import History from './History';
import Navigation from './Component/Navigation';
import BagdadChaseDeposit from './BagdadChaseDeposit';
import ManagementTeam from './ManagementTeam';
import Contact from './Contact'

function App() {


  const slideVariants = {
    initial: {
      x: '100%',  // Start from off-screen on the right
      opacity: 0, // Begin fully transparent for fade effect
    },
    animate: {
      x: '0%',    // Slide in to the center of the screen
      opacity: 1, // Fade to full opacity
      transition: {
        duration: 0.2,  // Adjust the duration as desired
        ease: 'easeOut', // Choose the easing function
      },
    },
    exit: {
      x: '-50%',  // Slide out to the left when the component exits
      opacity: 0, // Fade out to fully transparent
      transition: {
        duration: 0.2, // Adjust exit duration as needed
        ease: 'easeIn', // Smooth transition for exit
      },
    },
  };

  return (
    <div className=''>
      <Navigation />
      <div className='newsreader-bagdad '>
        <div className='mx-auto'>
          <Router>
            <div>

              <Switch>
                <motion.div
                  key="home"
                  initial="initial"
                  animate="animate"
                  variants={slideVariants}
                >
                  <Route exact path="/" component={Home} />
                  <Route exact path="/Home" component={Home} />


                  <Route exact path="/ManagementTeam" component={ManagementTeam} />
                  <Route exact path="/History" component={History} />
                  <Route exact path="/BagdadChaseDeposit" component={BagdadChaseDeposit} />
                  <Route exact path="/Contact" component={Contact} />
                </motion.div>
              </Switch>
              <footer>
                <Footer />
              </footer>
            </div>
          </Router>

        </div>
      </div>

    </div>
  );
}

export default App;
